/** The spinner a list shows while it loads, as the activity list does. */
export function LoadingState() {
  return (
    <div className="flex items-center justify-center py-12" role="status">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
      <span className="sr-only">Loading</span>
    </div>
  );
}

export function MessageState({ children }: { children: React.ReactNode }) {
  return (
    <p className="px-4 py-12 text-center text-sm text-gray-500">{children}</p>
  );
}
